"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var convertDecimalsToAlpha_1 = require("./convertDecimalsToAlpha");
var convertDecimalsToRomans_1 = require("./convertDecimalsToRomans");
var MarkerTypes;
(function (MarkerTypes) {
    MarkerTypes[MarkerTypes["Decimal"] = 0] = "Decimal";
    MarkerTypes[MarkerTypes["Roman"] = 1] = "Roman";
    MarkerTypes[MarkerTypes["Alpha"] = 2] = "Alpha";
})(MarkerTypes || (MarkerTypes = {}));
/**
 * @internal
 * Set marker style of a numbering list
 * @param listStyleType
 * @param li
 */
function setNumberingListMarkers(li, listStyleType, level) {
    var _a = numberingListStyle[listStyleType], markerSeparator = _a.markerSeparator, markerSecondSeparator = _a.markerSecondSeparator, markerType = _a.markerType, lowerCase = _a.lowerCase;
    var markerNumber = level.toString();
    if (markerType === MarkerTypes.Roman) {
        markerNumber = (0, convertDecimalsToRomans_1.default)(level, lowerCase);
    }
    else if (markerType === MarkerTypes.Alpha) {
        markerNumber = (0, convertDecimalsToAlpha_1.default)(level - 1, lowerCase);
    }
    var marker = markerSecondSeparator
        ? markerSecondSeparator + markerNumber + markerSeparator
        : markerNumber + markerSeparator;
    li.style.listStyleType = "\"" + marker + "\"";
}
exports.default = setNumberingListMarkers;
var numberingListStyle = (_a = {},
    _a[1 /* Decimal */] = {
        markerType: MarkerTypes.Decimal,
        markerSeparator: '. ',
    },
    _a[2 /* DecimalDash */] = {
        markerType: MarkerTypes.Decimal,
        markerSeparator: '- ',
    },
    _a[3 /* DecimalParenthesis */] = {
        markerType: MarkerTypes.Decimal,
        markerSeparator: ') ',
    },
    _a[4 /* DecimalDoubleParenthesis */] = {
        markerType: MarkerTypes.Decimal,
        markerSeparator: ') ',
        markerSecondSeparator: '(',
    },
    _a[5 /* LowerAlpha */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: '. ',
        lowerCase: true,
    },
    _a[8 /* LowerAlphaDash */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: '- ',
        lowerCase: true,
    },
    _a[6 /* LowerAlphaParenthesis */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: ') ',
        lowerCase: true,
    },
    _a[7 /* LowerAlphaDoubleParenthesis */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: ') ',
        markerSecondSeparator: '(',
        lowerCase: true,
    },
    _a[9 /* UpperAlpha */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: '. ',
    },
    _a[12 /* UpperAlphaDash */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: '- ',
    },
    _a[10 /* UpperAlphaParenthesis */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: ') ',
    },
    _a[11 /* UpperAlphaDoubleParenthesis */] = {
        markerType: MarkerTypes.Alpha,
        markerSeparator: ') ',
        markerSecondSeparator: '(',
    },
    _a[13 /* LowerRoman */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: '. ',
        lowerCase: true,
    },
    _a[16 /* LowerRomanDash */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: '- ',
        lowerCase: true,
    },
    _a[14 /* LowerRomanParenthesis */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: ') ',
        lowerCase: true,
    },
    _a[15 /* LowerRomanDoubleParenthesis */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: ') ',
        markerSecondSeparator: '(',
        lowerCase: true,
    },
    _a[17 /* UpperRoman */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: '. ',
    },
    _a[20 /* UpperRomanDash */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: '- ',
    },
    _a[18 /* UpperRomanParenthesis */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: ') ',
    },
    _a[19 /* UpperRomanDoubleParenthesis */] = {
        markerType: MarkerTypes.Roman,
        markerSeparator: ') ',
        markerSecondSeparator: '(',
    },
    _a);
//# sourceMappingURL=setNumberingListMarkers.js.map